(function () {
  'use strict';
  if (window.CSInspirationProductControls) { window.CSInspirationProductControls.mount(); return; }
  var mounted = new Map(), bars = new Set(), frame = 0;
  var selector = '[data-cs-inspiration-product]';
  var stickySelector = '[data-dn-sticky], [data-cbj-sticky], [data-cl26-mobile-sticky]';
  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(scheduleOffset) : null;
  var mutationObserver = typeof MutationObserver === 'function' ? new MutationObserver(scheduleOffset) : null;
  function syncOffset() {
    frame = 0;
    var host = document.querySelector('[data-cs-inspiration-root]');
    if (!host) return;
    var height = 0, nearForm = document.documentElement.classList.contains('cs-lead-form-visible');
    bars.forEach(function (bar) {
      var shown = bar.hasAttribute('data-dn-sticky') ? bar.hasAttribute('data-visible') : bar.classList.contains('is-visible') && !bar.classList.contains('is-form-visible');
      if (!bar.isConnected || bar.hidden) return;
      var style = window.getComputedStyle(bar);
      if (style.position !== 'fixed' || style.display === 'none' || style.visibility === 'hidden') return;
      var rect = bar.getBoundingClientRect();
      var stillExiting = rect.top < window.innerHeight && rect.bottom > 0;
      if ((shown && !nearForm) || stillExiting) height = Math.max(height, Math.ceil(rect.height));
    });
    var value = height + 'px';
    if (host.style.getPropertyValue('--cs-inspiration-sticky-height') !== value) host.style.setProperty('--cs-inspiration-sticky-height', value);
  }
  function scheduleOffset() { if (!frame) frame = window.requestAnimationFrame(syncOffset); }
  function watchBars() {
    if (mutationObserver) mutationObserver.disconnect();
    if (resizeObserver) resizeObserver.disconnect();
    bars = new Set(document.querySelectorAll(stickySelector));
    bars.forEach(function (bar) {
      if (resizeObserver) resizeObserver.observe(bar);
      if (mutationObserver) mutationObserver.observe(bar, {attributes:true,attributeFilter:['class','data-visible','hidden','aria-hidden']});
    });
    if (mutationObserver) mutationObserver.observe(document.documentElement, {attributes:true,attributeFilter:['class']});
    scheduleOffset();
  }
  function unmount(root) {
    var state = mounted.get(root); if (!state) return;
    state.save.removeEventListener('click', state.toggle);
    state.show.removeEventListener('click', state.open);
    state.unsubscribe(); mounted.delete(root);
    root.removeAttribute('data-cs-inspiration-mounted'); root.hidden = true;
  }
  function mount() {
    var api = window.CSInspiration;
    if (!api || !api.ready) return;
    mounted.forEach(function (state, root) { if (!root.isConnected) unmount(root); });
    document.querySelectorAll(selector).forEach(function (root) {
      if (mounted.has(root)) return;
      var key = root.dataset.csInspirationProduct;
      if (!/^[1-9][0-9]{0,19}$/.test(key)) return;
      var identity = {type:'product',key:key}, record = api.resolve(identity);
      if (!record || record.selectable !== true || record.state !== 'available') return;
      var save = root.querySelector('[data-cs-inspiration-save]'), show = root.querySelector('[data-cs-inspiration-show]');
      if (!save || !show) return;
      function selected() { return api.get().items.some(function (item) { return item.type === 'product' && item.key === key; }); }
      function refresh() {
        if (!root.isConnected) { unmount(root); return; }
        var saved = selected();
        save.setAttribute('aria-pressed', String(saved));
        save.textContent = saved ? save.dataset.labelSaved : save.dataset.labelSave;
      }
      function toggle() {
        var result = selected() ? api.remove(identity) : api.add(identity);
        if (result && result.ok === false) api.open(result.reason);
        refresh();
      }
      function open() { api.open(); }
      save.addEventListener('click', toggle); show.addEventListener('click', open);
      var unsubscribe = api.subscribe(refresh);
      mounted.set(root, {save:save,show:show,toggle:toggle,open:open,unsubscribe:unsubscribe});
      root.dataset.csInspirationMounted = 'true'; refresh(); root.hidden = false;
    });
    watchBars();
  }
  window.CSInspirationProductControls = {mount:mount};
  window.addEventListener('cs:inspiration-ready', mount);
  window.addEventListener('resize', scheduleOffset, {passive:true});
  if (window.visualViewport) window.visualViewport.addEventListener('resize', scheduleOffset, {passive:true});
  document.addEventListener('transitionend', function (event) { if (event.target.matches(stickySelector)) scheduleOffset(); }, true);
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', function (event) {
    mounted.forEach(function (state, root) { if (event.target.contains(root)) unmount(root); });
    watchBars();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true});
  else mount();
}());
